/**
 * Günsonu şube karşılaştırması — kategori satış miktarları.
 * Gram altın: ürün gramı × adet (1 g × 3 + 5 g × 2 = 13 g).
 */

export const GRAM_ALTIN_UNIT_WEIGHTS = {
  '1 Gram 22 Ayar': 1,
  '0.50 Gram 22 Ayar': 0.5,
  '0.25 Gram 22 Ayar': 0.25,
  '1 Gram 24 Ayar': 1,
  '0.50 Gram 24 Ayar': 0.5,
  '0.25 Gram 24 Ayar': 0.25,
  '2.50 Gram 24 Ayar': 2.5,
  '5 Gram 24 Ayar': 5,
  '10 Gram 24 Ayar': 10,
  '20 Gram 24 Ayar': 20,
  '50 Gram 24 Ayar': 50,
  '100 Gram 24 Ayar': 100,
};

const SARRAFIYE_NAMES = new Set([
  'Eski Ziynet Çeyrek',
  'Yeni Ziynet Çeyrek',
  'Eski Ziynet Yarım',
  'Yeni Ziynet Yarım',
  'Eski Ziynet Tam',
  'Yeni Ziynet Tam',
  "Eski Ziynet 2.5'lu Gremse",
  "Yeni Ziynet 2.5'lu Gremse",
  'Eski Ziynet Beşli',
  'Yeni Ziynet Beşli',
  'Cumhuriyet Ata Çeyrek',
  'Cumhuriyet Ata Yarım',
  'Cumhuriyet Ata',
  "Cumhuriyet Ata 2.5'lu Gremse",
  'Cumhuriyet Ata Beşli',
  'Reşat Çeyrek',
  'Reşat Yarım',
  'Reşat',
  "Reşat 2.5'lu Gremse",
  'Reşat Beşli',
]);

function round2(n) {
  return Math.round((Number(n) || 0) * 100) / 100;
}

export function parseGramAltinUnitWeight(urun) {
  const name = String(urun || '').trim();
  if (GRAM_ALTIN_UNIT_WEIGHTS[name] != null) return GRAM_ALTIN_UNIT_WEIGHTS[name];
  const m = name.match(/(\d+(?:[.,]\d+)?)\s*gram/i);
  if (!m) return 0;
  return Number.parseFloat(String(m[1]).replace(',', '.')) || 0;
}

export function detectSaleCategory(islem) {
  const kat = String(islem?.kategori || '').trim();
  const urun = String(islem?.urun || '').trim();
  if (kat === 'Takı Ürün' || kat === 'Takı') return 'taki';
  if (kat === 'Gram Altın') return 'gramAltin';
  if (kat === 'Sarrafiye') return 'sarrafiye';
  if (SARRAFIYE_NAMES.has(urun) || /ziynet|cumhuriyet\s*ata|re[sş]at/i.test(urun)) {
    return 'sarrafiye';
  }
  if (/\d+([.,]\d+)?\s*gram\s*(22|24)\s*ayar/i.test(urun) || kat === 'Gram Altın') {
    return 'gramAltin';
  }
  if (/ayar\s*(tak[ıi]|bilezik)/i.test(urun) || /tak[ıi]/i.test(urun)) return 'taki';
  return '';
}

export function emptyCategorySales() {
  return { takiGram: 0, gramAltinGram: 0, sarrafiyeAdet: 0 };
}

export function addCategorySale(acc, islem) {
  if (String(islem?.islemTuru || '') !== 'Satış') return acc;
  const cat = detectSaleCategory(islem);
  const adet = Number(islem?.adet) || 0;
  const gram = Number(islem?.gram) || 0;
  if (cat === 'taki') {
    acc.takiGram += gram > 0 ? gram : 0;
  } else if (cat === 'gramAltin') {
    const unit = parseGramAltinUnitWeight(islem?.urun);
    if (unit > 0 && adet > 0) acc.gramAltinGram += unit * adet;
    else if (unit > 0) acc.gramAltinGram += unit;
    else if (gram > 0) acc.gramAltinGram += gram;
  } else if (cat === 'sarrafiye') {
    acc.sarrafiyeAdet += adet > 0 ? adet : 0;
  }
  return acc;
}

export function summarizeCategorySales(islemler) {
  const acc = emptyCategorySales();
  (islemler || []).forEach((i) => addCategorySale(acc, i));
  acc.takiGram = round2(acc.takiGram);
  acc.gramAltinGram = round2(acc.gramAltinGram);
  acc.sarrafiyeAdet = round2(acc.sarrafiyeAdet);
  return acc;
}
